import { PropsWithChildren } from 'react';
import { CssBaseline, createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { AppThemeOverrides } from './AppThemeOverrides';
import { CompanySettingsMap } from '../Configuration/CompanySettingsMap';
import { useAppSelector } from '../store';
import { AppSettings } from '../Configuration/types';
import deepmerge from 'deepmerge';

export default function AppThemeProvider(props: PropsWithChildren & { appSettings: AppSettings }) {
	const company = props.appSettings.company;
	const companySettings = CompanySettingsMap[company];
	const selectedTerminal = useAppSelector((state) => state.applicationState.selectedTerminal);

	const divisionTheme = selectedTerminal?.scac ? companySettings.divisions[selectedTerminal.scac.toUpperCase()].theme : {};

	const theme = createTheme({
		...deepmerge.all([AppThemeOverrides, companySettings.theme, divisionTheme]),
		cssVariables: true
	});

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<CssBaseline enableColorScheme />
				{props.children}
			</ThemeProvider>
		</StyledEngineProvider>
	);
}
